import React, {useState, useMemo, useCallback, useEffect} from 'react';
import useStockChart from "../../charts/useStockChart";
import {createFutureDateRange} from "../../utils/datetime";
import StockChart from "../../charts/StockChart";
import {sampleColors} from "../../utils/colors";
import {toRGB} from "../../utils/colorUtils";


const SimulationPaths = ({ paths, title }) => {
    console.log(paths)
    const stockChart = useStockChart();

    const timestamps = useMemo(() => {
        return createFutureDateRange(paths[0].length);
    }, [paths]);

    const formattedSeriesData = useMemo(() => {
        return stockChart.formatChartTimeseriesWithSharedIndex({
            timestamps, seriesArrays: paths,
            opacity: 0.5,
        })
    }, [paths]);
    const plotConfig = useMemo(() => {
        return stockChart.createPlot({
            data: formattedSeriesData,
            legendProps: {format: "%", precision: 2},
        })
    });


    return (
        <div style={{height: 550, width: '100%'}}>
            <StockChart height={550} dataSeries={[plotConfig]} disableLegend={true} disableTooltip={true} />
        </div>
    )

}

export default SimulationPaths;